// not yet ideal but trying to round up all color variables here.
// if you find hardcoded colors please put them here and try and dedupe them

export const solarColorArray = [
  '#fff292',
  '#ffeb81',
  '#ffe471',
  '#ffdc5e',
  '#ffd349',
  '#ffcc33',
  '#fbbb3b',
  '#f7aa41',
  '#f29945',
  '#ed8749',
  '#e8754c',
];

export const windColorArray = [
  '#bfd6e2',
  '#abc8d7',
  '#98bacc',
  '#87acc0',
  '#779eb3',
  '#6890a5',
  '#5a8197',
  '#4e7488',
  '#43667a',
  '#39596a',
  '#304c5b',
];
export const windOffshoreColorArray = [
  '#c7d9db',
  '#afdadd',
  '#a4dadd',
  '#9ed9dd',
  '#92d9dd',
  '#86d9dd',
  '#7ad8de',
  '#6ed8de',
  '#5cd8de',
  '#41d8df',
  '#06d8e0',
];

// when all energy source are selected
export const allColorArray = [
  '#b7dcad',
  '#a2d094',
  '#8cc47c',
  '#7ab769',
  '#67aa58',
  '#579d4a',
  '#488f3e',
  '#3b8134',
  '#2e742d',
  '#236628',
  '#1a5924',
];

export const priceColor = '#212952';
